import { render, staticRenderFns } from "./ParaClinic.vue?vue&type=template&id=250a24b9&"
import script from "./ParaClinic.vue?vue&type=script&lang=js&"
export * from "./ParaClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports